/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMaximize, faBars } from '@fortawesome/free-solid-svg-icons'
import HTMLFlipBook from 'react-pageflip'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function PageFlipPreview({ srcs, isMediaVisible, redirectUrl }) {
  const containerRef = useRef(null)
  const [showTop, setShowTop] = useState(false)

  const bottomImg = srcs.find((s) => s.label === 'Bottom img')
  const topImages = srcs
    .filter((s) => s.label?.startsWith('Top img'))
    .sort((a, b) => {
      const getNum = (label) => parseInt(label.match(/\d+$/)?.[0] || '0', 10)
      return getNum(a.label) - getNum(b.label)
    })

  const getPreviewURL = (file) => {
    if (file instanceof File || file instanceof Blob) {
      return URL.createObjectURL(file)
    }
    if (typeof file === 'string' && file.startsWith('blob:')) {
      return file
    }
    return ''
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '2%' }}
        />
        <div style={{ position: 'relative' }}>
          <div
            className="border-bottom mb-3 d-flex"
            style={{ width: '240px', height: '55px', zIndex: '0' }}
          >
            <div className="w-80 m-auto ms-auto">
              <Image src={wavenet_logo} className="w-75 ps-3" />
            </div>
            <div className="w-20 m-auto ms-auto d-flex">
              <FontAwesomeIcon icon={faBars} className="text-end" />
            </div>
          </div>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>
      <div
        style={{
          objectFit: 'cover',
          height: 'auto',
          position: 'absolute',
          bottom: '12%',
          width: '240px',
          zIndex: '1000',
        }}
      >
        <div
          ref={containerRef}
          className="position-relative"
          style={{
            width: '240px',
            minHeight: 'auto',
            margin: '0 auto',
          }}
        />
      </div>
      <div style={{ position: 'relative', paddingTop: '1rem' }}>
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <br />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
        <div className="text-line" />
      </div>

      <div>
        {isMediaVisible && !showTop && bottomImg?.file && (
          <div style={{ position: 'absolute', width: '240px', bottom: '12%' }}>
            <Button
              style={{
                position: 'absolute',
                top: '-35px',
                left: '1%',
                zIndex: 1101,
                background: 'white',
                border: '1px solid #000',
                borderRadius: '50%',
                padding: '4px 8px',
                fontSize: '14px',
                cursor: 'pointer',
              }}
              onClick={() => setShowTop(true)}
            >
              <FontAwesomeIcon
                className="text-dark animate-pulse"
                icon={faMaximize}
              />
            </Button>

            <img
              src={getPreviewURL(bottomImg.file)}
              alt="Bottom Img"
              className="w-100"
            />

            <CIIcon />
          </div>
        )}

        {showTop && (
          <div
            style={{
              position: 'absolute',
              bottom: '20%',
              right: '8.5%',
              transform: 'translateX(-50%)',
              width: '240px',
              zIndex: 1100,
            }}
          >
            <Button
              onClick={() => setShowTop(false)}
              style={{
                position: 'absolute',
                top: '-24px',
                right: '5px',
                zIndex: 1101,
                width: '22px',
                height: '22px',
                border: 'none',
                borderRadius: '50%',
                backgroundColor: 'rgb(0 0 0 / 50%)',
                fontSize: '14px',
                lineHeight: '24px',
                cursor: 'pointer',
                padding: '0px 10px 5px 8px',
                alignContent: 'center',
              }}
            >
              ✕
            </Button>

            <HTMLFlipBook
              width={240}
              height={360}
              size="stretch"
              minWidth={240}
              maxWidth={240}
              minHeight={360}
              maxHeight={360}
              showCover={false}
              usePortrait
              drawShadow={false}
              flippingTime={1000}
              startPage={0}
              style={{ width: '100%', height: '100%' }}
              onFlip={(e) => {
                if (e.data === topImages.length - 1 && redirectUrl) {
                  setTimeout(() => {
                    window.open(redirectUrl, '_blank')
                  }, 500)
                }
              }}
            >
              {topImages.map((img, i) => (
                <div key={i}>
                  <img
                    src={getPreviewURL(img.file)}
                    alt={`Top Page ${i + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                  <CIIcon />
                </div>
              ))}
            </HTMLFlipBook>
          </div>
        )}
      </div>
    </div>
  )
}

PageFlipPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ),
  isMediaVisible: PropTypes.bool.isRequired,
  redirectUrl: PropTypes.string,
}

PageFlipPreview.defaultProps = {
  srcs: [],
  redirectUrl: '',
}

export default PageFlipPreview
